import { templates } from "../data/en";

(self as any).__oz_localization_templates = templates;
